export enum TimelineTimeframes {
  Month = 'month',
  Quarter = 'quarter',
  Year = 'year',
  FiveYears = 'five-years',
}
